import React from "react";
import { Link, useHistory } from "react-router-dom";
import { triggerBase64Download } from "common-base64-downloader-react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import DownloadForOfflineIcon from "@mui/icons-material/DownloadForOffline";

import { IconButton } from "@mui/material";
import { WHITE } from "../colors";
import DownloadService from "../services/downloadService";

export default function DocumentsListContainer(props) {
  const { userClicked } = props;
  let history = useHistory();
  const saveFile = async (url) => {
    var urlSplitted = url.split(".");
    var fileFormat = urlSplitted[urlSplitted.length - 1];
    const encodedResponse = await DownloadService.downloadFromUrl({ url });
    const base64data =
      `data:application/${fileFormat.toLowerCase() === "pdf" ? "pdf" : "octet-stream"};base64,` +
      encodedResponse.data.data;
    triggerBase64Download(base64data, "download_name");
  };

  const filtered = props?.filteredCustomer
    ? props?.docs?.filter((c) => c.customer === props?.filteredCustomer)
    : props?.docs;
  return (
    <div>
      <TableContainer component={Paper} sx={{ maxHeight: 440, opacity: 0.9, borderRadius: 4 }}>
        <Table
          sx={{
            minWidth: 650,
            backgroundColor: WHITE,
          }}
          aria-label="simple table"
          stickyHeader
          aria-label="sticky table"
        >
          <TableHead>
            <TableRow>
              {/* <TableCell padding="checkbox">
                <Checkbox color="primary" checked={false} />
              </TableCell> */}
              <TableCell>Time</TableCell>
              <TableCell align="center">Type</TableCell>
              <TableCell align="center">Related Employee</TableCell>
              <TableCell align="center">Related Customer</TableCell>
              <TableCell align="center">Description</TableCell>
              <TableCell align="center">Download</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filtered?.map((row) => (
              <TableRow
                hover
                // onClick={() =>
                //   history.push(`${FORM_SUBMIT_ROUTE}?type=${row.type}&customer=${row.customer}&form=${row.id}`)
                // }
                key={row.id}
                sx={{
                  "&:last-child td, &:last-child th": {
                    border: 0,
                  },
                }}
              >
                {/* <TableCell padding="checkbox">
                  <Checkbox color="primary" checked={false} />
                </TableCell> */}

                <TableCell>{row.updatedAt}</TableCell>
                <TableCell align="center">{row.mediaType}</TableCell>
                <TableCell align="center">{row?.Employee?.name}</TableCell>
                <TableCell align="center">{row?.Customer?.full_name}</TableCell>
                <TableCell align="center">{row.description}</TableCell>

                <TableCell align="center">
                  {/* <a href={row.filePath} download target="_blank"> */}
                  <IconButton onClick={() => saveFile(row.filePath)}>
                    <DownloadForOfflineIcon />
                  </IconButton>
                  {/* </a> */}

                  {/* <a href={row?.filePath} download> */}

                  {/* </a> */}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}
